import React from 'react';
import { graphql } from 'gatsby';

import BlogCategoryFeed from '../../components/blogs/BlogCategoryFeed/BlogCategoryFeed';
import BlogFeed from '../../components/blogs/BlogFeed/BlogFeed';
import BasicSingleColumn from '../../components/common/BasicSingleColumn/BasicSingleColumn';
import BlocksOnly from '../../components/common/BlocksOnly/BlocksOnly';
import CommonFeedWrapper from '../../components/common/CommonFeedWrapper/CommonFeedWrapper';
import HeroSingleColumn from '../../components/common/HeroSingleColumn/HeroSingleColumn';
import TwoColumnRight from '../../components/common/TwoColumnRight/TwoColumnRight';
import WordpressSEO from '../../components/common/WordpressSEO/WordpressSEO';
import NewsroomPage from '../../components/newsroom/NewsroomPage/NewsroomPage';
import CareersTemplate from '../CareersTemplate';
import PPQTemplate from '../PPQTemplate';

export default ({ data }) => {
  const template = data.page.templateFields.templateStyle;
  let selectedTemplate;

  switch (template) {
    case 'twoColumnRight':
      selectedTemplate = <TwoColumnRight data={data} />;
      break;
    case 'blogFeed':
      selectedTemplate = <BlogFeed data={data} />;
      break;
    case 'blogCategoryFeed':
      selectedTemplate = <BlogCategoryFeed data={data} />;
      break;
    case 'feedPage':
      selectedTemplate = <CommonFeedWrapper data={data} />;
      break;
    case 'ppqForm':
      selectedTemplate = <PPQTemplate data={data.page} />;
      break;
    case 'careers':
      selectedTemplate = <CareersTemplate data={data.page} />;
      break;
    case 'newsroomPage':
      selectedTemplate = <NewsroomPage data={data} />;
      break;
    case 'blocksOnly':
      selectedTemplate = <BlocksOnly data={data} />;
      break;
    case 'heroOneColumn':
      selectedTemplate = <HeroSingleColumn data={data} />;
      break;
    default:
      selectedTemplate = <BasicSingleColumn data={data} />;
      break;
  }

  return <WordpressSEO data={data.page}>{selectedTemplate}</WordpressSEO>;
};

export const query = graphql`
  query page($id: String!) {
    page: wpPage(id: { eq: $id }) {
      title
      slug
      uri
      content
      ...GetAllSEOPageFields
      ...GetAllTemplateFields
      featuredImage {
        node {
          localFile {
            ...HeroImage
          }
          sourceUrl
          altText
        }
      }
    }

    post: allWpPost(filter: { categories: { nodes: { elemMatch: { slug: { eq: "blog" } } } } }) {
      nodes {
        ...GetAllBlogPosts
      }
    }

    story: allWpPost(filter: { categories: { nodes: { elemMatch: { slug: { eq: "stories" } } } } }) {
      nodes {
        ...GetAllHomeownerStoryPosts
      }
    }

    resource: allWpPost(filter: { categories: { nodes: { elemMatch: { slug: { eq: "homeowner-resources" } } } } }) {
      nodes {
        ...GetAllHomeownerResourcePosts
      }
    }

    newsroom: allWpPost(filter: { categories: { nodes: { elemMatch: { slug: { eq: "newsroom-press-story" } } } } }) {
      nodes {
        ...GetAllNewsroomPressStories
      }
    }

    pressRelease: allWpPost(filter: { categories: { nodes: { elemMatch: { slug: { eq: "press-release" } } } } }) {
      nodes {
        title
        date
        content
        uri
      }
    }

    category: allWpCategory {
      edges {
        node {
          name
          link
          slug
          wpChildren {
            nodes {
              name
              slug
            }
          }
        }
      }
    }
  }
`;
